// src/utils/styleConstants.js

// Font Styles
export const fontStyles = [
 { font: "Roboto", size: 10.5, color: [220, 20, 60], fontWeight: "bold" },          // crimson
{ font: "Caveat", size: 12, color: [255, 140, 0], fontWeight: "bold" },           // darkorange
{ font: "DancingScript", size: 12, color: [30, 144, 255], fontWeight: "bold" },   // dodgerblue
{ font: "Dosis", size: 10.9, color: [34, 139, 34], fontWeight: "bold" },            // forestgreen
{ font: "IndieFlower", size: 11, color: [255, 105, 180], fontWeight: "bold" },    // hotpink
{ font: "Quicksand", size: 9.5, color: [255, 215, 0], fontWeight: "bold" }        // #FFD700

  
];

// Label Colors
export const labelColors = [
  "#191970",  // Midnight Blue
  "#006400",  // Dark Green
  "#B22222",  // Firebrick Red
  "#D35400",  // Shiny Burnt Orange

  "#DC143C",  // Crimson Red
];

// Value Colors
export const valueColors = [
  "#800080",  // Purple
  "#D35400" , // Shiny Burnt Orange


  "#00008B",  // Dark Blue
  "#006400",  // Dark Green
  "#4169E1",  // Royal Blue
];

// Line Colors
export const lineColors = [
  "#228B22",  // Forest Green
  "#FF1493",  // Deep Pink
  "#FFD700",  // Golden Yellow
  "#4682B4",  // Steel Blue
  "#D2691E",  // Chocolate Brown
];
